import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {ForgotPasswordComponent} from "./forgot-password.component";
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [ForgotPasswordComponent],
    imports     : [BrowserModule, ReactiveFormsModule],
})

export class ForgotPasswordModule {}


// WEBPACK FOOTER //
// ./src/app/views/forgot-password/forgot-password.module.ts